export const ADMIN = "ADMIN";
export const FMANRACING_JWT_TOKEN_KEY = "fmanracing-jwt-token";